import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'
import { FaEdit, FaTimes } from 'react-icons/fa';

const CitiesTable = ({
    cities,
    onDelete,
    onEdit
}) => {

    const columns = React.useMemo(
        () => [
            {
                header: 'Name',
                accessorKey: 'name'
            },
            {
                header: 'Created By',
                accessorKey: 'user.name'
            },
            {
                header: 'Date Created',
                accessorKey: 'created_at'
            },
            {
                header: 'Date Updated',
                accessorKey: 'updated_at'
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaTimes
                            className='fa-times'
                            data-toggle='tooltip'
                            title='Delete'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                        />

                        <FaEdit
                            className='fa-edit'
                            data-toggle='tooltip'
                            title='Edit'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                        />
                    </>
                )
            }
        ],
        [onDelete, onEdit]
    );

    const table = useReactTable({
        data: cities,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (cities.length === 0){
        return <div className="text-center">No cities found</div>
    }

  return (
    <table className='table table-striped table-hover'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default CitiesTable